import { useQuery } from '@tanstack/react-query'
import { useActions } from '../../store'
import { useErrorHandler } from '../useErrorHandler'
import { useResponseHandler } from '../useResponseHandler'
import { useAuth, useTenant } from '../'

const { env } = window
const PER_PAGE = 10

const useAdminAffiliations = ({ search, page, sort }) => {
  const { securedFetch } = useAuth()
  const { handleError } = useErrorHandler()
  const { handleResponse } = useResponseHandler()
  const { progressStart, progressEnd } = useActions()
  const { tenant } = useTenant()

  const getAdminAffiliations = async (tenantId) => {
    const offset = (page - 1) * PER_PAGE
    const sortParams = sort.reduce((result, item) => {
      result += `&sort.${item.id}=${item.desc ? 'desc' : 'asc'}`
      return result
    }, '')
    const searchParam = search ? `&search=${search}` : ''
    const url = encodeURI(
      `${env.apiUrl}/tenants/${tenantId}/affiliations?max=${PER_PAGE}` +
        `&offset=${offset}${sortParams}${searchParam}`
    )
    const response = await securedFetch(url)
    await handleResponse(response)
    return response.json()
  }

  const query = useQuery({
    queryKey: ['admin-affiliations', tenant?.id, search, page, sort],
    queryFn: () => getAdminAffiliations(tenant?.id)
  })

  if (query.isPending) {
    progressStart()
  } else if (query.isSuccess) {
    progressEnd()
  } else if (query.isError) {
    handleError(query.error, 'Error getting groups')
    progressEnd()
  }

  return {
    affiliations: query.data?.items,
    count: query.data?.count,
    total: query.data?.total,
    pageCount: query.data ? Math.ceil(query.data.count / PER_PAGE) : undefined
  }
}

export { useAdminAffiliations }
